import axios from 'axios';
import store from '@/store';
import router from '@/router.js';
import axiosRetry, { exponentialDelay } from 'axios-retry';

const MAX_RETRY = 2;
const RETRY_NUMBER = 5;
const API_BASE = {
  baseURL: process.env.API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
};

const requestInterceptors = request => {
  const refresh = localStorage.getItem('refresh');
  return axios
    .create(API_BASE)
    .post('refresh/', { refresh })
    .then(res => {
      request.headers.Authorization = 'JWT ' + res.data.data.idToken;
      return request;
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

const rejectRequestInterceptors = error => {
  return Promise.reject(error);
};

const responseInterceptors = response => {
  return response;
};

const rejectResponseInterceptors = error => {
  const status = error.response ? error.response.status : 500;
  const isCloudsignReview = localStorage.getItem('isCloudsignReview') === 'true';
  const loginName = isCloudsignReview ? 'LoginForCloudsignReview' : 'Login';
  if (status === 401) {
    store.dispatch('auth/logout');
    router.push({
      name: loginName
    });
    store.dispatch('message/setWarningMessage', {
      title: 'セッションタイムアウト',
      message: 'セッションがタイムアウトしました。再度ログインしてください。'
    });
  } else if (status === 403) {
    store.dispatch('auth/logout');
    router.push({
      name: loginName
    });
    store.dispatch('message/setErrorMessage', {
      message: error.response.data.error
    });
  } else {
    store.dispatch('message/setErrorMessage', {
      message: '想定外のエラーです。'
    });
  }
  return Promise.reject(error);
};

// apiWithoutAuthentication
const apiWithoutAuthentication = axios.create(API_BASE);
apiWithoutAuthentication.interceptors.response.use(responseInterceptors, rejectResponseInterceptors);

// default api
const api = axios.create(API_BASE);
axiosRetry(api, {
  retries: MAX_RETRY,
  retryDelay: () => exponentialDelay(RETRY_NUMBER)
});
api.install = function(Vue) {
  Object.defineProperty(Vue.prototype, '$request', {
    get() {
      return api;
    }
  });
};
api.interceptors.request.use(requestInterceptors, rejectRequestInterceptors);
api.interceptors.response.use(responseInterceptors, rejectResponseInterceptors);

// apiWithoutResponseInterceptors
const apiWithoutResponseInterceptors = axios.create(API_BASE);
apiWithoutResponseInterceptors.interceptors.request.use(requestInterceptors, rejectRequestInterceptors);

const apiWithoutInterceptors = axios.create(API_BASE);

export default api;
export { apiWithoutAuthentication, apiWithoutResponseInterceptors, apiWithoutInterceptors };



// WEBPACK FOOTER //
// ./src/services/api.js